import { render, staticRenderFns } from "./FlowOverview.vue?vue&type=template&id=0afc0858&scoped=true&"
import script from "./FlowOverview.vue?vue&type=script&lang=js&"
export * from "./FlowOverview.vue?vue&type=script&lang=js&"
import style0 from "./FlowOverview.vue?vue&type=style&index=0&id=0afc0858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc0858",
  null
  
)

export default component.exports